// removed by extract-text-webpack-plugin
module.exports = {"CommentLength":"___EditReview__CommentLength___1FTOv","Header":"___EditReview__Header___3XGg6","MustLeaveComment":"___EditReview__MustLeaveComment___3YfQT","AspectReview":"___EditReview__AspectReview___2oXg1","selected":"___EditReview__selected___3pCej","Aspect":"___EditReview__Aspect___1jE9t"};


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Place/EditReview.less
// module id = 1026
// module chunks = 0